import type { MetricsGranularity } from './metricsScope';

export type PeriodFreshnessKind = 'current-month' | 'current-year' | 'closed-month' | 'closed-year';

export interface PeriodFreshnessInput {
  period: string;
  year: number;
  month: number;
  granularity?: MetricsGranularity;
}

/** El mes/año calendario de `now` aún no cerró: los totales son parciales. */
export function resolvePeriodFreshness(
  input: PeriodFreshnessInput,
  now: Date = new Date()
): PeriodFreshnessKind {
  const nowYear = now.getFullYear();
  const nowMonth = now.getMonth() + 1;
  const isYearView = input.granularity === 'year' || /^\d{4}$/.test(input.period);

  if (isYearView) {
    return input.year >= nowYear ? 'current-year' : 'closed-year';
  }

  if (input.year > nowYear || (input.year === nowYear && input.month >= nowMonth)) {
    return 'current-month';
  }
  return 'closed-month';
}

export function isPartialPeriod(kind: PeriodFreshnessKind): boolean {
  return kind === 'current-month' || kind === 'current-year';
}
